import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ResponseDto } from '../../../shared/dtos/response.dto';
import { TransferContractDto } from '../dtos/transfer-contract.dto';

@Injectable({
    providedIn: 'root'
})
export class TransferContractService {
    public constructor(private http: HttpClient) {}

    public transferContract(data: TransferContractDto): Observable<ResponseDto> {
        return this.http.post<ResponseDto>(environment.outgoingRequestAPI + 'Contract/editpac', data);
    }
}
